// extracted by mini-css-extract-plugin
module.exports = {"InputNumber":"InputNumber_InputNumber__nBtH4","large":"InputNumber_large__3f-Nh","small":"InputNumber_small__17ngI"};